import { render, staticRenderFns } from "./alluser.vue?vue&type=template&id=e5abc20a&scoped=true&"
import script from "./alluser.vue?vue&type=script&lang=js&"
export * from "./alluser.vue?vue&type=script&lang=js&"
import style0 from "./alluser.vue?vue&type=style&index=0&id=e5abc20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5abc20a",
  null
  
)

export default component.exports